import React from 'react';
import { useTheme } from '@mui/material/styles';
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation';

import { ThemeProps } from '@styles/theme';
import { messages } from '@shared/components/components.messages';
import { useStyles } from './OrientationGuard.styles';

/**
 * CSS-only overlay shown when a phone is held in landscape (coarse pointer +
 * short viewport). Tablets are excluded by the max-height in `theme.phoneLandscape`.
 * Visibility is driven entirely by the media query so it can never flicker.
 */
export const OrientationGuard: React.FC = () => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    return (
        <div className={styles.overlay} role="alertdialog" aria-live="polite">
            <ScreenRotationIcon className={styles.icon} />
            <p className={styles.title}>{messages['orientationGuard.title']}</p>
            <p className={styles.text}>{messages['orientationGuard.text']}</p>
        </div>
    );
};
